module.exports = __webpack_public_path__ + "static/media/1-6.84183be1.mp3";